
// import './Footer.css';
// import React, { useState } from 'react';
// import { CiSearch } from 'react-icons/ci';
// import { GrNext } from "react-icons/gr";
// import { FaFacebookF } from "react-icons/fa";
// import { FaLinkedinIn } from "react-icons/fa";
// import { IoLogoTwitter } from "react-icons/io";

// import { Link, useNavigate } from 'react-router-dom';
// import { BASE_URL, Token } from '../Config';
// import axios from 'axios'

// function Footer() {

//     const [input, setInput] = useState("");
//     const [error, setError] = useState(null);
//     const data = [
//         { id: 1, title: "SSC Exam", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] },
//         { id: 2, title: "UPSC Exam", content: ["Content 1 for Paper-2", "Content 2 for Paper-2", "Content 3 for Paper-2"] },
//         { id: 3, title: "UPSSC", content: ["Content 1 for Paper-3", "Content 2 for Paper-3", "Content 3 for Paper-3"] },
//         { id: 4, title: "UPPCS-Mains", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] }
//     ];

//     const data1 = [
//         { id: 1, title: "Students", content: ["Login / Signup", "Refer & Earn", "Book Free Demo", "FAQ", "Feedback & Reviews", "Get a Callback","Help & Support"] },
//         { id: 2, title: "Company profile", content: ["About Us", "Why Us", "Our Team", "Career", "Media & Press Release", "Blogs", "Contact Us"] },
//         { id: 3, title: "Teacher", content: ["Login", "Register Now", "FAQ", "Feedback & Reviews", "Teacher Benefits", "Get a Callback","Help & Support"] },
//         { id: 4, title: "What We Do", content: ["Test Series", "Live Classes", "Interviews", "Teacher on Call", "Classroom", "Resources", "Current Affairs", "Free Mockup Test"] },
//         { id: 5, title: "Important Links", content: ["Terms of Use", "Privacy Policy", "Refunds & Cancellations", "Cookies Policy", "Disclaimer", "Report Abuse"] }
//     ];
//     const contentLinks = {
//         "Login / Signup": "/login",
//         "About Us": "/company-aboutus",
//         "Career": "/career",
//         "Media & Press Release":"/media-page",
//         "Media & Press Release":"/media-page",
//         "Blogs":"/blogs",
//         "Terms of Use":"/terms-condition",
//         "Privacy Policy" :"/privacy-policy",
//         "Test Series" :"/test-series-page",
//         "Live Classes" :"/live-classes",
//         "Interviews" :"/live-interview",
//         "Teacher on Call" :"/teacher-on-call",
//         "Current Affairs" :"/current-affairs",
//         "Cookies Policy":"/cookies",
//         "Resources":"/resources",
//         "Refer & Earn":"/refers-&-earns",
//         "Login":"https://themetoaster.site/examtime/teacher/login",
//         "Book Free Demo":"/demo-booking",
//         "Get a Callback":"/get-callback",
//         "Feedback & Reviews":"/student-share-feedback",
//         "Contact Us":"/contact-us",
//         "Register Now":"/teacher-registration",
//         "FAQ":"/faq",
//         "Our Team":"/our-team",
//         "Why Us":"/why-us",
//         "Disclaimer":"/disclaimer",
//         "Refunds & Cancellations":"/refunds-and-cancellations",
//         "Report Abuse":"/report-an-abuse",
//         "Classroom":"/classroom",
//         "Help & Support":"/help-supports"

//     };
//     const subscribnewsletter = async (e) => {
//         e.preventDefault();
//         if (!input) {
//             setError('Please enter E-mail.');
//             return;
//         }
//         const formData = new FormData();
//         formData.append("email", input);
//         try {
//             const response = await axios.post(BASE_URL + "subscribenewsletter", formData, {
//                 headers: {
//                     "content-type": "multipart/form-data",
//                     Accept: "application/json",
//                 },
//             });
//             if (response.data.success === true) {

//             }


//         } catch (error) {
//             if (error.response) {
//                 // Handle error response
//             } else if (error.request) {
//                 console.log(error.request);
//             } else {
//                 console.log("Error", error.message);
//             }
//             console.log(error.config);
//         }
//     };

//     return (
//         <div className="footer-page ">
//             <div className='footer--top--card  mb-5'>
//                 {data.map(item => (
//                     <div key={item.id} className='footer--heading mt-5'>
//                         <h4>{item.title}</h4>
//                         <div className='footer--subheading mt-3'>
//                             {item.content.map((subItem, index) => (
//                                 <p className='m-0 ' key={index}><GrNext /> {subItem}</p>
//                             ))}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <div className='subscribe mt-5 mb-3'>
//                 <h5>Subscribe Newsletters</h5>
//                 <div className="input-group ">
//                     <input type="text" className="form-control" placeholder="Enter your email" aria-label="Search" aria-describedby="basic-addon2" onChange={((e) => setInput(e.target.value))} />
//                     <div className="input-group-append">
//                         <span className="input-group-text" id="basic-addon2" onClick={subscribnewsletter} style={{ cursor: "pointer" }}>Subcribe Now</span>

//                     </div>
//                     {error && <div className="text-white">{error}</div>}
//                 </div>
//             </div>
//             <div className='footer--top--card  mb-5'>
//                 {data1.map(item => (
//                     <div key={item.id} className='footer--heading mt-3'>
//                         <h4>{item.title}</h4>
//                         <div className='footer--subheading mt-3'>
//                             {item.content.map((subItem, index) => (
//                                 <p className='m-0 ' key={index}>
//                                     {contentLinks[subItem] ? (
//                                         <Link className='redirect-link' to={contentLinks[subItem]} >{subItem}</Link>

//                                     ) : (
//                                         subItem
//                                     )}
//                                 </p>
//                             ))}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <div className='footer--bottom mb-2'>
//                 <div className='footer--bottom--left--side'>

//                 </div>
//                 <div className='footer--bottom--right--side'>
//                     <p><FaFacebookF /></p>
//                     <p><FaLinkedinIn /></p>
//                     <p><IoLogoTwitter /></p>
//                 </div>
//             </div>
//             <div className='footer--bottom'>
//                 <div className='footer--bottom--left--side1'>

//                     <p >© 2019 The Exam Time. All rights reserved.</p>

//                 </div>
//                 <div className='footer--bottom--right--side1'>
//                     <Link to={"/terms-condition"} style={{ textDecoration: "none", color: "#000000" }}>
//                         <p>Terms of Service</p>
//                     </Link>
//                     <Link to={"/privacy-policy"} style={{ textDecoration: "none", color: "#000000" }}>
//                         <p> Privacy Policy</p>
//                     </Link>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Footer;
// import './Footer.css';
// import React, { useState,useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { BASE_URL } from '../Config';
// import axios from 'axios';
// import { FaRegCopyright } from 'react-icons/fa6';

// function Footer() {
//     const [input, setInput] = useState("");
//     const [error, setError] = useState(null);
//     useEffect(() => {

//         footersection();
//       }, []);
//     const [footerdata,setFooterdata] = useState('')
//     const [footertext,setFootertext] = useState('')
//     const footersection = async () => {
//         try {
//           const response = await axios.get(`${BASE_URL}generalsetting`, {
//             headers: {
//               "content-type": "multipart/form-data",
//               Accept: "application/json",
//             },
//           });
//           if (response.data.success === true) {
//             setFootertext(response.data.data)
//             setFooterdata(response.data.setting);
//           } else {
//             setFooterdata();
//           }
//         } catch (error) {
//           console.error("Error fetching SEO data:", error);
//         }
//       };
//     const data = [
//         { id: 1, title: "SSC Exam", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] },
//         { id: 2, title: "UPSC Exam", content: ["Content 1 for Paper-2", "Content 2 for Paper-2", "Content 3 for Paper-2"] },
//         { id: 3, title: "UPSSC", content: ["Content 1 for Paper-3", "Content 2 for Paper-3", "Content 3 for Paper-3"] },
//         { id: 4, title: "UPPCS-Mains", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] },
//         { id: 5, title: "UPPCS-Mains", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] }
//     ];

//     const data1 = [
//         { id: 1, title: "Students", content: [
//             { id: 'student_login', text: "Login / Signup" },
//             { id: 'refer_earn', text: "Refer & Earn" },
//             { id: 'book_free_demo', text: "Book Free Demo" },
//             { id: 'student_faq', text: "FAQ" },
//             { id: 'student_feedback_reviews', text: "Feedback & Reviews" },
//             { id: 'get_a_call_back', text: "Get a Callback" },
//             { id: 'help_support', text: "Help & Support" }
//         ]},
//         { id: 2, title: "Company profile", content: [
//             { id: 'about_us', text: "About Us" },
//             { id: 'why_us', text: "Why Us" },
//             { id: 'our_team', text: "Our Team" },
//             { id: 'career', text: "Career" },
//             { id: 'media_press_release', text: "Media & Press Release" },
//             { id: 'blogs', text: "Blogs" },
//             { id: 'contact_us', text: "Contact Us" }
//         ]},
//         { id: 3, title: "Teacher", content: [
//             { id: 'teacher_login', text: "Login" },
//             { id: 'teacher_registration', text: "Register Now" },
//             { id: 'teacher_faq', text: "FAQ" },
//             { id: 'teacher_feedback_reviews', text: "Feedback & Reviews" },
//             { id: 'teacher_benefits', text: "Teacher Benefits" },
//             { id: 'teacher-callback', text: "Get a Callback" },
//             { id: 'teacher-support', text: "Help & Support" }
//         ]},
//         { id: 4, title: "What We Do", content: [
//             { id: 'test_series', text: "Test Series" },
//             { id: 'live_classes', text: "Live Classes" },
//             { id: 'interviews', text: "Interviews" },
//             { id: 'teacher_on_call', text: "Teacher on Call" },
//             { id: 'classrooms', text: "Classroom" },
//             { id: 'resources', text: "Resources" },
//             { id: 'current_affairs', text: "Current Affairs" },
//             { id: 'free_mockup_test', text: "Free Mockup Test" }
//         ]},
//         { id: 5, title: "Important Links", content: [
//             { id: 'terms_conditions', text: "Terms of Use" },
//             { id: 'privacy_policy', text: "Privacy Policy" },
//             { id: 'refund_cancellation_policy', text: "Refunds & Cancellations" },
//             { id: 'cookies_policy', text: "Cookies Policy" },
//             { id: 'disclaimer', text: "Disclaimer" },
//             { id: 'report_abuse', text: "Report Abuse" }
//         ]}
//     ];

//     const contentLinks = {
//         'student_login': "/login",
//         'refer_earn': "/refers-&-earns",
//         'book_free_demo': "/demo-booking",
//         'student_faq': "/faq",
//         'student_feedback_reviews': "/student-share-feedback",
//         'get_a_call_back': "/get-callback",
//         'help_support': "/help-supports",
//         'about_us': "/company-aboutus",
//         'why_us': "/why-us",
//         'our_team': "/our-team",
//         'career': "/career",
//         'media_press_release': "/media-page",
//         'blogs': "/blogs",
//         'contact_us': "/contact-us",
//         'teacher_login': "https://themetoaster.site/examtime/teacher/login",
//         'teacher_registration': "/teacher-registration",
//         'teacher_faq': "/faq-teacher",
//         'teacher_feedback_reviews': "/student-share-feedback",
//         'teacher_benefits': "/teacher-benefits",
//         'teacher-callback': "/get-callback",
//         'teacher-support': "/help-supports-teacher",
//         'test_series': "/test-series-page",
//         'live_classes': "/live-classes",
//         'interviews': "/live-interview",
//         'teacher_on_call': "/teacher-on-call",
//         'classrooms': "/classroom",
//         'resources': "/resources",
//         'current_affairs': "/current-affairs",
//         'free_mockup_test': "/free-mockup-page",
//         'terms_conditions': "/terms-condition",
//         'privacy_policy': "/privacy-policy",
//         'refund_cancellation_policy': "/refunds-and-cancellations",
//         'cookies_policy': "/cookies",
//         'disclaimer': "/disclaimer",
//         'report_abuse': "/report-an-abuse"
//     };

//     const subscribnewsletter = async (e) => {
//         e.preventDefault();
//         if (!input) {
//             setError('Please enter E-mail.');
//             return;
//         }
//         const formData = new FormData();
//         formData.append("email", input);
//         try {
//             const response = await axios.post(BASE_URL + "subscribenewsletter", formData, {
//                 headers: {
//                     "content-type": "multipart/form-data",
//                     Accept: "application/json",
//                 },
//             });
//             if (response.data.success === true) {
//                 // handle success
//             }
//         } catch (error) {
//             if (error.response) {
//                 // Handle error response
//             } else if (error.request) {
//                 console.log(error.request);
//             } else {
//                 console.log("Error", error.message);
//             }
//             console.log(error.config);
//         }
//     };

//     const filteredData = data1.map(section => {
//         const filteredContent = section.content.filter(item => footerdata[item.id] === 'yes');
//         return { ...section, content: filteredContent };
//       });


//     return (
//         <div className="footer-page ">
//             <div className='footer--top--card mb-5 pb-5' style={{borderBottom:"0.4px solid #0000001a"}}>
//                 {data.map(item => (
//                     <div key={item.id} className='footer--heading mt-5'>
//                         <h4>{item.title}</h4>
//                         <div className='footer--subheading mt-3'>

//                             {item.content.map((subItem, index) => (
//                                 <p className='m-0 ' key={index}> {subItem}</p>
//                             ))}
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div className='footer--top--card mb-5'>
//                 {filteredData.map(item => (
//                     <div key={item.id} className='footer--heading mt-3'>
//                         <h4>{item.title}</h4>
//                         <div className='footer--subheading mt-3'>
//                             {item.content.map(subItem => (
//                                 <p className='m-0' key={subItem.id}>
//                                     {contentLinks[subItem.id] ? (
//                                         <Link className='redirect-link' to={contentLinks[subItem.id]}>{subItem.text}</Link>
//                                     ) : (
//                                         subItem.text
//                                     )}
//                                 </p>
//                             ))}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <div className='footer--bottom mb-2'>
//                 <div className='footer--bottom--left--side'>
//                     {/* Add left side content here if any */}
//                 </div>
//                 <div className='footer--bottom--right--side'>

//                 </div>
//             </div>
//             <div className='footer--bottom'>
//                 <div className='footer--bottom--left--side1'>
//                     <p><FaRegCopyright /> {footertext.footer_copyright}</p>
//                 </div>
//                 <div className='footer--bottom--left--side1'>
//                     <a href='https://www.webmingo.com/' >
//                     <p>Design & Developed by <span>Web Mingo IT Solutions Pvt. Ltd.</span></p>
//                     </a>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Footer;
import './Footer.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../Config';
import axios from 'axios';
import { FaRegCopyright } from 'react-icons/fa6';
import { FaArrowRight } from 'react-icons/fa';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import thanks from '../Assets/thanku1.png'
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  bgcolor: "#f9f9f9",
  //   border: '2px solid #000',
  borderRadius: 2,
  boxShadow: 24,
  p: 2,
  Width: 600,
  width: { xs: "90%", sm: "500px" },
  height: "auto",
};

function Footer() {
    const [input, setInput] = useState("");
    const [error, setError] = useState(null);
    const [expandedSections, setExpandedSections] = useState({});
    const [data, setData] = useState([]); // Combined data
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        footersection();
    }, []);

    const [footerdata, setFooterdata] = useState('');
    const [footertext, setFootertext] = useState('');
    const [open1, setOpen1] = React.useState(false);
    const handleOpen = (e) => {

        setOpen1(true);
    };
    const handleClose1 = () => setOpen1(false);

    const footersection = async () => {
        try {
            const response = await axios.get(`${BASE_URL}generalsetting`, {
                headers: {
                    "content-type": "multipart/form-data",
                    Accept: "application/json",
                },
            });
            if (response.data.success === true) {
                setFootertext(response.data.data);
                setFooterdata(response.data.setting);
            } else {
                setFooterdata();
            }
        } catch (error) {
            console.error("Error fetching SEO data:", error);
        }
    };
   useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}competitivecomission`);
      if (response.data && response.data.data) {
        const commissions = response.data.data;

        const updatedData = await Promise.all(
          commissions.map(async (commission) => {
            try {
              const examResponse = await axios.get(
                `${BASE_URL}exaamcategorybycomission/${commission.slug}`
              );

              const exams = examResponse.data?.data || [];

              return {
                id: commission.id,
                title: commission.exam_type,
                slug: commission.slug,
                content: exams.map((exam) => ({
                  id: exam.id,
                  title: exam.category_name,
                  slug: exam.slug,
                })),
              };
            } catch (innerError) {
              console.error(
                `Error fetching exams for commission ID ${commission.id}:`,
                innerError
              );
              return {
                id: commission.id,
                title: commission.exam_type,
                slug: commission.slug,
                content: [], // empty instead of failing all
              };
            }
          })
        );

        setData(updatedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching commissions:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);





    // const data = [
    //     { id: 1, title: "SSC Exam", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] },
    //     { id: 2, title: "UPSC Exam", content: ["Content 1 for Paper-2", "Content 2 for Paper-2", "Content 3 for Paper-2"] },
    //     { id: 3, title: "UPSSC", content: ["Content 1 for Paper-3", "Content 2 for Paper-3", "Content 3 for Paper-3"] },
    //     { id: 4, title: "UPPCS-Mains", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] },
    //     { id: 5, title: "UPPCS-Mains", content: ["Paper-1 (सामान्य हिंदी)", "Paper-2 (Essay)", "Paper-3 (GS-1)", "Paper-4 (GS-2)", "Paper-5 (GS-3)", "Paper-6 (GS-4)"] }
    // ];

    const data1 = [
        {
            id: 1, title: "Company profile", content: [
                { id: 'about_us', text: "About Us" },
                { id: 'why_us', text: "Why Us" },
                { id: 'our_team', text: "Our Team" },
                { id: 'career', text: "Career" },
                { id: 'media_press_release', text: "Media & Press Release" },
                { id: 'blogs', text: "Blogs" },
                { id: 'contact_us', text: "Contact Us" },
                { id: 'latest_news', text: "Latest News" }
            ]
        },
        {
            id: 2, title: "What We Do", content: [
                { id: 'test_series', text: "Test Series" },
                { id: 'live_classes', text: "Live Classes" },
                { id: 'interviews', text: "Interviews" },
                { id: 'teacher_on_call', text: "Teacher on Call" },
                { id: 'classrooms', text: "Classroom" },
                { id: 'resources', text: "Resources" },
                { id: 'current_affairs', text: "Current Affairs" },
                { id: 'free_mockup_test', text: "Free Mockup Test" }
            ]
        },
        {
            id: 3, title: "Students", content: [
                { id: 'student_login', text: "Login / Signup" },
                { id: 'refer_earn', text: "Refer & Earn" },
                { id: 'book_free_demo', text: "Book Free Demo" },
                { id: 'student_faq', text: "FAQ" },
                { id: 'student_feedback_reviews', text: "Feedback & Reviews" },
                { id: 'get_a_call_back', text: "Get a Callback" },
                { id: 'help_support', text: "Help & Support" }
            ]
        },

        {
            id: 4, title: "Teacher", content: [
                { id: 'teacher_login', text: "Login" },
                { id: 'teacher_registration', text: "Register Now" },
                { id: 'teacher_faq', text: "FAQ" },
                { id: 'teacher_feedback_reviews', text: "Feedback & Reviews" },
                { id: 'teacher_benefits', text: "Teacher Benefits" },
                { id: 'teacher-callback', text: "Get a Callback" },
                { id: 'teacher-support', text: "Help & Support" }
            ]
        },

        {
            id: 5, title: "Important Links", content: [
                { id: 'terms_conditions', text: "Terms of Use" },
                { id: 'privacy_policy', text: "Privacy Policy" },
                { id: 'refund_cancellation_policy', text: "Refunds & Cancellations" },
                { id: 'cookies_policy', text: "Cookies Policy" },
                { id: 'disclaimer', text: "Disclaimer" },
                { id: 'report_abuse', text: "Report Abuse" }
            ]
        }
    ];

    const contentLinks = {
        'student_login': "/log-in",
        'refer_earn': "/refers-&-earns",
        'book_free_demo': "/demo-booking",
        'student_faq': "/faq",
        'student_feedback_reviews': "/student-share-feedback",
        'get_a_call_back': "/get-callback",
        'help_support': "/help-supports",
        'about_us': "/company-aboutus",
        'why_us': "/why-us",
        'our_team': "/our-team",
        'career': "/career",
        'media_press_release': "/media-page",
        'blogs': "/blogs",
        'contact_us': "/contact-us",
        'teacher_login': "https://eagledemo.online/theexamtime/teacher/login",
        'teacher_registration': "/teacher-registration",
        'teacher_faq': "/faq-teacher",
        'teacher_feedback_reviews': "/teacher-share-feedback",
        'teacher_benefits': "/teacher-benefits",
        'teacher-callback': "/get-callback",
        'teacher-support': "/help-supports-teacher",
        'test_series': "/test-series-page",
        'live_classes': "/live-classes",
        'interviews': "/live-interview",
        'teacher_on_call': "/teacher-on-call",
        'classrooms': "/classroom",
        'resources': "/resources",
        'current_affairs': "/current-affairs",
        'free_mockup_test': "/free-mockup-page",
        'terms_conditions': "/terms-condition",
        'privacy_policy': "/privacy-policy",
        'refund_cancellation_policy': "/refunds-and-cancellations",
        'cookies_policy': "/cookies",
        'disclaimer': "/disclaimer",
        'report_abuse': "/report-an-abuse",
        'latest_news': "/latest-news"
    };

    const subscribnewsletter = async (e) => {
        e.preventDefault();
        if (!input) {
            setError('Please enter E-mail.');
            return;
        }
        const formData = new FormData();
        formData.append("email", input);
        try {
            const response = await axios.post(BASE_URL + "subscribenewsletter", formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Accept: "application/json",
                },
            });
            if (response.data.success === true) {
                // handle success
                setInput('')
                setOpen1(true);
            }
        } catch (error) {
            if (error.response) {
                // Handle error response
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log("Error", error.message);
            }
            console.log(error.config);
        }
    };

    const toggleSection = (id) => {
        setExpandedSections(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const filteredData = data1.map(section => {
        const filteredContent = section.content.filter(item => footerdata[item.id] === 'yes');
        return { ...section, content: filteredContent };
    });
    
    return (
        <div className="footer-page ">
            <div className='footer--top--card mb-3 pb-5' style={{ borderBottom: "0.4px solid #0000001a" }}>
                {data.map(item => (
                    <div key={item.id} className='footer--heading mt-5'>
                        <h4>{item.title}</h4>
                        <div className='footer--subheading mt-3'>
                            {item.content.slice(0, expandedSections[item.id] ? item.content.length : 4).map((subItem) => (
                                <>
                                {footerdata.test_series=="yes"?<Link className='redirect-link' style={{textDecoration:"none", color:"#000"}} to={`/subject-details/${subItem.slug}`}>
                                <p className='m-0' key={subItem.id}> {subItem.title} </p> 
                                </Link>:
                                <Link className='redirect-link' style={{textDecoration:"none", color:"#000"}} to={`/comming-soon`}>
                                <p className='m-0' key={subItem.id}> {subItem.title} </p> 
                                </Link>
                                }
                                
                                </>
                            ))}

                            {item.content.length > 4 && (
                                <p className='m-0'>
                                    <a href="#" onClick={(e) => { e.preventDefault(); toggleSection(item.id); }}>
                                        {expandedSections[item.id] ? "Read Less" : "Read More"}
                                    </a>
                                </p>
                            )}
                        </div>
                    </div>
                ))}

            </div>
            <div className='subscribe  mb-3'>
                <h5>Subscribe Newsletters</h5>
                <div className="input-group ">
                    <input type="text" className="form-control" placeholder="Enter your email" aria-label="Search" aria-describedby="basic-addon2" onChange={((e) => setInput(e.target.value))} />
                    <div className="input-group-append">
                        <span className="input-group-text" id="basic-addon2" onClick={subscribnewsletter} style={{ cursor: "pointer" }}><FaArrowRight /></span>
                    </div>
                    {error && <div className="text-white">{error}</div>}               
                      </div>
            </div>
            <div className='footer--top--card mb-5'>
                {filteredData.map(item => (
                    <div key={item.id} className='footer--heading mt-3'>
                        <h4>{item.title}</h4>
                        <div className='footer--subheading mt-1 mb-3'>
                            {item.content.map(subItem => (
                                <p className='m-0' key={subItem.id}>
                                    {contentLinks[subItem.id] ? (
                                        <Link className='redirect-link' to={contentLinks[subItem.id]} style={{ color: "#000" }}>{subItem.text}</Link>
                                    ) : (
                                        subItem.text
                                    )}
                                </p>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className='footer--bottom mb-2'>
                <div className='footer--bottom--left--side'>
                    {/* Add left side content here if any */}
                </div>
                <div className='footer--bottom--right--side'>

                </div>
            </div>
            <div className='footer--bottom'>
                <div className='footer--bottom--left--side1 '>
                    <p className='ml-3'> <FaRegCopyright className='' style={{ marginTop: "-3px" }} /> <span style={{ marginTop: "6px", marginLeft: "3px", paddingTop: "10px" }}>{footertext.footer_copyright}</span></p>
                </div>
                <div className='footer--bottom--left--side1 footer_bootom_webmingo1' >
                    <a href='https://www.webmingo.com/' >
                        <p>Design & Developed by <span className='' style={{ color: "blue" }}>Web Mingo</span></p>
                    </a>
                </div>
                <div className=' footer_bootom_webmingo' >
                    <a href='https://www.webmingo.com/' >
                        <p>Design & Developed by <span className='' style={{ color: "blue" }}>Web Mingo</span></p>
                    </a>
                </div>
            </div>
            <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className="cross-button">
                        <h5 className="" style={{ cursor: "pointer" }} onClick={handleClose1}>X</h5>
                    </div>
                    <section class="introduction-inner ">
                        <div class="container">
                            <div class="row">

                                <div class="col-lg-12 col-md-12 col-sm-12 ">

                                    <div class="login-page1">
                                        <h2>Thank You</h2>
                                        <p>Thank You for Submitting your Request, You will receive the Application Download Link on your Mobile soon.</p>
                                        <div class="login-page-image-thanku">
                                            <div class="thanku-image">
                                                <img src={thanks} alt="thanks" />
                                            </div>


                                        </div>

                                        <a href={'/'}> <button style={{ backgroundColor: "#E93014", border: "none", borderRadius: "3px", color: "white", padding: "2px 10px" }}> Back To Home </button></a>
                                        <p>If you have any issues Contact us</p>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </section>
                </Box>
            </Modal>
        </div>
    );
}

export default Footer;
